export const getBr = (text: string) => {
  if (text.includes('|')) {
    return text.split('|').join('<br/>');
  }
  return text.replace(/\n/g, '<br/>');
};
